import { render } from "./creditor-index.vue?vue&type=template&id=0d959a3b&scoped=true"
import script from "./creditor-index.vue?vue&type=script&lang=js"
export * from "./creditor-index.vue?vue&type=script&lang=js"

import "./creditor-index.vue?vue&type=style&index=0&id=0d959a3b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d959a3b"]])

export default __exports__